<template>
  <div class="pie-chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs';

export default {
  extends: Pie,
  name: 'CallLogByTypePieChart',
  props: {
    callLogs: {
      type: Array,
      required: true,
    },
  },
  watch: {
    callLogs: {
      immediate: true,
      handler() {
        if (this.callLogs.length > 0) this.updateChart();
      },
    },
  },
  methods: {
    updateChart() {
      console.log('Updating CallLogByTypePieChart with callLogs:', this.callLogs);
      if (this.callLogs.length === 0) return;

      const inboundCount = this.callLogs.filter(call => call.call_type === 'inbound').length;
      const outboundCount = this.callLogs.filter(call => call.call_type === 'outbound').length;

      this.renderChart(
        {
          labels: [
            this.$t('CALL_LOG_REPORT.TYPE.INBOUND'),
            this.$t('CALL_LOG_REPORT.TYPE.OUTBOUND'),
          ],
          datasets: [{
            data: [inboundCount, outboundCount],
            backgroundColor: ['#10b981', '#f59e0b'],
            borderWidth: 2,
            borderColor: '#fff',
          }],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
            },
          },
        }
      );
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.pie-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>